import React, { useEffect } from 'react';
import store from 'store2';
import { connect } from 'react-redux';
import queryString from 'query-string';
import {
  jsonToQueryString,
  loadRoute,
  strictValidObjectWithKeys,
  strictValidString,
} from '../../../utils/commonUtils';
import { likeJob } from './actions';

const ApplyFromThirdParty = ({ dispatch, match, user, location }) => {
  const { params } = match;
  const { id, type } = params;
  const { search } = location;
  const metaData = queryString.parse(search);

  const onAuthenticatedUser = async () => {
    const res = await dispatch(likeJob(id, metaData));
    if (res) {
      store({
        likejob: id,
        likejobmeta: metaData,
      });
      loadRoute(dispatch, '/');
    }
  };

  useEffect(() => {
    // Reroute to apply URL if job id is missing
    if (!strictValidString(id) || type !== 'job') {
      loadRoute(dispatch, '/apply');
      return;
    }

    if (strictValidObjectWithKeys(user)) {
      onAuthenticatedUser();
    } else {
      store({
        likejob: id,
        likejobmeta: metaData,
      });
      loadRoute(dispatch, `/apply?job=${id}&${jsonToQueryString(metaData)}`);
    }
  }, [user]);

  return false;
};

export default connect((state) => ({
  user: state.get('auth').get('user'),
}))(ApplyFromThirdParty);
